import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { contactParentRejection } from '../../modules/contactParentRequired'
import {
  getCompanyContactListData,
  processAfterAddOrChangeToCompanyContactListData,
  processAfterDeleteOfCompanyContactListData,
} from './mockData'
import type { ICompanyContact } from '~/types/company/models'

interface GetCompanyContactsResponse {
  data: ICompanyContact[]
}

async function getCompanyContacts(
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) {
  const responseBody: GetCompanyContactsResponse = {
    data: await getCompanyContactListData(),
  }
  return res(ctx.status(200), ctx.json(responseBody))
}

// post

const postCompanyContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return (
    (await contactParentRejection(req, res, ctx, {
      parentKey: 'company',
      modelName: 'CompanyContact',
    })) ??
    addToEntityListData(
      req,
      res,
      ctx,
      getCompanyContactListData,
      processAfterAddOrChangeToCompanyContactListData
    )
  )
}

const patchCompanyContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getCompanyContactListData, [
    processAfterAddOrChangeToCompanyContactListData,
  ])
}

const deleteCompanyContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(
    req,
    res,
    ctx,
    getCompanyContactListData,
    processAfterDeleteOfCompanyContactListData
  )
}

export const handlers = [
  {
    method: 'get',
    path: '/api/companycontacts',
    handler: getCompanyContacts,
  },
  {
    method: 'post',
    path: '/api/companycontacts',
    handler: postCompanyContact,
  },
  {
    method: 'patch',
    path: '/api/companycontacts/:id',
    handler: patchCompanyContact,
  },
  {
    method: 'delete',
    path: '/api/companycontacts/:id',
    handler: deleteCompanyContact,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
